import axios from "axios";
import { storageKeys } from "../Constants/storage.key";
import { storage } from "./storage.service";
import { errorHandling } from "./error.handling";

// Variável para controlar se já estamos redirecionando
let isRedirecting = false;

// Promise do refresh em curso: evita múltiplas chamadas simultâneas ao refresh-token
let refreshPromise = null;

const api = axios.create({
  headers: {
    "Access-Control-Allow-Origin": "*",
    // "Content-Type": "application/json",
    "Access-Control-Allow-Credentials": true,
  },
  crossDomain: true,
});

api.interceptors.request.use(async (config) => {
  const requestUrl = (config?.url || "").toLowerCase();
  const isPublicValidateEmail = requestUrl.includes("/config/validate-email");

  if (
    !requestUrl.includes("/auth/login") &&
    !requestUrl.includes("/auth/password") &&
    !requestUrl.includes("/authorized/login") &&
    !requestUrl.includes("/refresh-token") &&
    !isPublicValidateEmail
  ) {
    let token = recoverToken();

    if (process.env.ENVIRONMENT === "TEST") {
      token = "bearer " + process.env.REACT_APP_MOCK_TOKEN; //mock
    }

    if (token) {
      config.headers.Authorization = token;
    }
  }

  if (requestUrl.includes("domain")) {
    //const host = document.location.host;
    // TODO: Alterar para PRD
    console.warn("TODO: Dominio setado a força. Remover!");
    const host = "ofv2.dev.thetos.com.br";
    //const host = document.location.host;
    console.log(`Host que está acessando: %c${host}`, "color:#55AAFF");

    config.headers["domainName"] = host;
  }

  if (!(config.data instanceof FormData)) {
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const requestUrl = (originalRequest?.url || "").toLowerCase();
    const isPublicValidateEmail = requestUrl.includes("/config/validate-email");

    if (isPublicValidateEmail) {
      return Promise.reject(error);
    }

    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const tokenData = storage.get(storageKeys.access_and_token);

        if (!tokenData?.refreshToken) {
          throw new Error('No refresh token available');
        }

        // Uma única chamada de refresh: se já houver refresh em curso, esperar e reutilizar o novo token
        if (!refreshPromise) {
          refreshPromise = (async () => {
            const refreshPayload = {
              token: tokenData.token,
              refreshToken: tokenData.refreshToken
            };

            const refreshResponse = await axios.post(
              `${process.env.REACT_APP_API_AUTH_BASE_URL}/v3/auth/refresh-token`,
              refreshPayload
            );

            const treated = errorHandling.handleResponse(refreshResponse, "api.refreshToken");

            if (treated?.token || treated?.Token) {
              const newTokenData = {
                token: treated.token || treated.Token,
                tokenExpiresAt: treated.tokenExpiresAt || treated.TokenExpiresAt,
                refreshToken: treated.refreshToken || treated.RefreshToken,
                refreshTokenExpiresAt: treated.refreshTokenExpiresAt || treated.RefreshTokenExpiresAt
              };

              storage.save(storageKeys.access_and_token, newTokenData);
              return newTokenData;
            }

            throw new Error('Refresh response invalid');
          })();
        }

        const newTokenData = await refreshPromise;
        refreshPromise = null;

        if (newTokenData?.token) {
          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers.Authorization = `bearer ${newTokenData.token}`;
          return api(originalRequest);
        }

        throw new Error('No token after refresh');
      } catch (refreshError) {
        refreshPromise = null;
        console.log('❌ Refresh token também expirou. Redirecionando para login...');

        localStorage.removeItem(storageKeys.access_and_token);

        if (!isRedirecting) {
          isRedirecting = true;
          window.location = "/#/";
        }

        return Promise.reject(refreshError);
      }
    }

    // Se não for 401 ou refresh falhou, verificar se deve redirecionar
    if (error?.response?.status === 401 && !isRedirecting) {
      isRedirecting = true;
      localStorage.removeItem(storageKeys.access_and_token);
      window.location = "/#/";
    }

    return Promise.reject(error);
  }
);

const recoverToken = () => {
  const token = localStorage.getItem(storageKeys.access_and_token);

  if (token) {
    const parsed = JSON.parse(token);
    return "bearer " + parsed.token;
  }
  return null;
};

export default api;